import React, { FC } from 'react';
import RatesModal from 'containers/retail/sections/energy-rates-3/RatesModal';
import RatesConsultationForm from 'containers/retail/sections/energy-rates-3/RatesConsultationForm';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import Desktop from 'evcharging/components/Desktop';
import RatesDescription from 'containers/retail/sections/energy-rates-3/RatesDescription';
import Mobile from 'evcharging/components/Mobile';

export interface RetailCustomQuoteModalProps {
  onClose: () => void;
  show: boolean;
  zipCode: string;
  utilityName: string;
  customerType: string;
}

const RatesCustomQuoteModal: FC<RetailCustomQuoteModalProps> = (props) => {
  const { onClose, show, ...rest } = props;

  return (
    <RatesModal open={show} onClose={onClose}>
      <Title variant={'p'} fontSize={28}>Looking for the best electricity rates?</Title>
      <Spacer value={12} />
      <Desktop>
        <RatesDescription>
          Please leave your contact info and our Customer Service Representative will get back to you with the best energy deal within one business day.
        </RatesDescription>
      </Desktop>
      <Mobile>
        <RatesDescription>
          Please leave your contact info.
        </RatesDescription>
      </Mobile>
      <br/>
      <RatesConsultationForm onDone={onClose} {...rest} />
    </RatesModal>
  );
};

export default RatesCustomQuoteModal;